import XLSX from "xlsx";
import JSZip from "jszip";
import FileSaver from "file-saver";

import _ from "lodash";

export default class FileXLSX {
    static download(title: string, data: any[], cols: any[]) {
        const dataWS = XLSX.utils.json_to_sheet(data, { skipHeader: false });
        const dataWB = XLSX.utils.book_new();

        dataWS["!margins"] = {
            left: 1.0,
            right: 1.0,
            top: 1.0,
            bottom: 1.0,
            header: 0.5,
            footer: 0.5,
        };
        dataWS["!cols"] = cols;

        XLSX.utils.book_append_sheet(dataWB, dataWS, "Sheet1");
        XLSX.writeFile(dataWB, `${title}.xlsx`);
    }

    static downloadAsZip(
        items: { title: string; data: any[]; columns: any[] }[]
    ) {
        let zip = new JSZip();
        if (items.length === 1) {
            this.download(items[0].title, items[0].data, items[0].columns);
        } else {
            (items || []).forEach((item) => {
                const dataWS = XLSX.utils.json_to_sheet(item.data, {
                    skipHeader: false,
                });
                const dataWB = XLSX.utils.book_new();

                dataWS["!margins"] = {
                    left: 1.0,
                    right: 1.0,
                    top: 1.0,
                    bottom: 1.0,
                    header: 0.5,
                    footer: 0.5,
                };
                dataWS["!cols"] = item.columns;
                XLSX.utils.book_append_sheet(dataWB, dataWS, "Sheet1");
                let workbook = XLSX.write(dataWB, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "binary",
                });
                zip.file(`${item.title}.xlsx`, workbook, { binary: true });
            });
            zip.generateAsync({ type: "blob" }).then((content) => {
                FileSaver.saveAs(content, `multiple-converted.zip`);
            });
        }
    }

    static getColumnsForData(data: any[]) {
        return _.keys(data[0]).map((key) => {
            const maxRow = _.maxBy(data, (r) => (r[key] + "").length);
            if (maxRow) {
                const maxValueLength = maxRow[key] ? maxRow[key].length : 0;
                let wch =
                    maxValueLength <= 27.5
                        ? maxValueLength < key.length
                            ? key.length
                            : maxValueLength
                        : 27.5;
                return { wch: wch + 5 };
            }
            return null;
        });
    }
    static upload(file: any) {
        return new Promise((resolve, reject) => {
            if (file) {
                let fileReader = new FileReader();
                fileReader.readAsBinaryString(file);
                fileReader.onload = (event: any) => {
                    let data = event.target.result;
                    let workbook = XLSX.read(data, { type: "binary", cellDates: true });
                    let sheetNames = workbook.SheetNames;
                    sheetNames.forEach((y: any) => {
                        var worksheets = workbook.Sheets[y];
                        var headers = {};
                        var data = [];
                        for (let worksheet in worksheets) {
                            if (worksheet[0] === "!") continue;

                            let col = worksheet.substring(0, 1);
                            let row = parseInt(worksheet.substring(1));
                            let value = worksheets[worksheet].v;

                            if (row === 1) {
                                headers[col] = value;
                                continue;
                            }

                            if (!data[row]) data[row] = {};
                            data[row][headers[col]] = value;
                        }

                        data.shift();
                        data.shift();
                        resolve({ data, headers });
                    });
                };
            } else {
                reject();
            }
        });
    }
}
